import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

export default function FallbackLoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await fetch('/api/auth/fallback', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password })
      });
      const data = await response.json();

      if (!response.ok) {
        setError(data.error || 'Unable to log in');
        setLoading(false);
        return;
      }

      sessionStorage.setItem('sessionToken', data.sessionToken);
      sessionStorage.setItem('userEmail', data.email);
      navigate('/upload');
    } catch (err) {
      setError('Connection error. Try again.');
      setLoading(false);
    }
  };

  return (
    <div className="container">
      <h1>Enhanced UIO</h1>
      <form onSubmit={handleSubmit}>
        <label htmlFor="fallback-email">Email Address</label>
        <input
          id="fallback-email"
          type="email"
          value={email}
          onChange={(event) => setEmail(event.target.value)}
          placeholder="you@tvi-mp3.com"
          required
          autoFocus
        />

        <label htmlFor="fallback-password" className="spaced-label">Shared Password</label>
        <input
          id="fallback-password"
          type="password"
          value={password}
          onChange={(event) => setPassword(event.target.value)}
          required
        />

        <div style={{ marginTop: 16 }}>
          <button type="submit" disabled={loading}>
            {loading ? 'Logging In' : 'Log In'}
          </button>
        </div>
        {error && <div className="error">{error}</div>}
      </form>
      <div className="footer">
        <Link to="/">Back to email login</Link>
      </div>
    </div>
  );
}
